<div class="flex flex-column flex-wrap align-content-center align-items-center my-auto">
    <h3 class="mt-5">Modificar perfil</h3>
    <p>Última modificación hecha el {{ person?.lastUpdated | date: "dd 'de' MMMM 'de' yyyy 'a las' hh:mm:ss a": "":"co" }}</p>
    <form [formGroup]="personForm" (ngSubmit)="updatePerson()" class="w-6">
        <div *ngIf="isAdmin">
            <div class="field my-5">
                <span class="p-float-label">
                    <input id="idDocument" type="text" pInputText class="p-inputtext-lg w-full" formControlName="idDocument"
                        maxlength="45" />
                    <label htmlFor="idDocument">Número de documento</label>
                </span>
            </div>
            <div class="field mb-5">
                <span class="p-float-label">
                    <textarea rows="5" cols="30" id="notes" pInputTextarea class="p-inputtext-lg w-full" formControlName="notes">
                    </textarea>
                    <label htmlFor="notes">Notas</label>
                </span>
                <label class="contador">{{ this.personForm.get('notes')?.value.length }}/2000</label>
            </div>
        </div>
        <div class="field my-5">
            <span class="p-float-label">
                <input id="name" type="text" pInputText class="p-inputtext-lg w-full" formControlName="name"
                    maxlength="100" autofocus="true"
                    [class.ng-invalid]="this.personForm.get('name')?.invalid && this.personForm.get('name')?.touched" />
                <label htmlFor="name">Nombre</label>
            </span>
        </div>
        <div class="field mb-5">
            <span class="p-float-label">
                <input type="text" id="age" pInputText class="p-inputtext-lg w-full" formControlName="age"
                    maxlength="2"
                    [class.ng-invalid]="this.personForm.get('age')?.invalid && this.personForm.get('age')?.touched" />
                <label htmlFor="age">Edad</label>
            </span>
        </div>
        <div class="formgrid grid">
            <div class="field col mb-5">
                <span class="p-float-label">
                    <p-dropdown formControlName="city" inputId="city" [options]="cities" optionLabel="name" styleClass="w-12 p-inputtext-lg" 
                    placeholder="Ciudad" emptyMessage="No hay registros" (onChange)="onCitySelection($event)"
                        [class.ng-invalid]="this.personForm.get('city')?.invalid && this.personForm.get('city')?.touched"></p-dropdown>
                    <label htmlFor="city">Ciudad</label>
                </span>
            </div>
            <div class="field col mb-5">
                <span class="p-float-label">
                    <p-dropdown formControlName="locality" inputId="locality" [options]="localities" optionLabel="name" styleClass="w-12 p-inputtext-lg" 
                        emptyMessage="No hay registros" placeholder="Localidad"
                        [class.ng-invalid]="this.personForm.get('locality')?.invalid && this.personForm.get('locality')?.touched"></p-dropdown>
                    <label htmlFor="locality">Localidad</label>
                </span>
            </div>
        </div>
        <div class="field mb-5">
            <span class="p-float-label">
                <p-inputNumber inputId="pricePerHour" formControlName="pricePerHour" prefix="$" [maxlength]="6" styleClass="p-inputtext-lg" 
                    inputStyleClass="w-7" [size]="90"
                    [class.ng-invalid]="this.personForm.get('pricePerHour')?.invalid && this.personForm.get('pricePerHour')?.touched"></p-inputNumber>
                <label htmlFor="pricePerHour">Tarifa por hora</label>
            </span>
            <p-checkbox formControlName="showPrice" label="Mostrar en el perfil" styleClass="mt-2"
                [binary]="true" 
                inputId="binary" />
        </div>
        <div class="field mb-5">
            <label htmlFor="servicePlaces" style="color: rgba(255, 255, 255, 0.6); font-size: 12px;">Lugar de atención</label>
            <p-skeleton width="324px" height="39px" *ngIf="servicePlaces.length === 0"></p-skeleton>
            <p-skeleton width="324px" height="39px" *ngIf="servicePlaces.length === 0"></p-skeleton>
            <p-selectButton id="servicePlaces" [options]="servicePlaces" formControlName="servicePlaces" 
                [multiple]="true" optionLabel="description" ></p-selectButton>
        </div>
        <div class="field mb-5">
            <span class="p-float-label">
                <input type="text" id="schedule" pInputText class="p-inputtext-lg w-full" formControlName="schedule"
                    maxlength="100"
                    [class.ng-invalid]="this.personForm.get('schedule')?.invalid && this.personForm.get('schedule')?.touched" />
                    <label htmlFor="schedule">Horario de atención</label>
            </span>
        </div>
        <div class="field mb-5">
            <span class="p-float-label">
                <textarea rows="5" cols="30" id="description" pInputTextarea class="p-inputtext-lg w-full" formControlName="description"
                    [class.ng-invalid]="this.personForm.get('description')?.invalid && this.personForm.get('description')?.touched">
                </textarea>
                <label htmlFor="description">Descripción de servicios</label>
            </span>
            <label class="contador">{{ this.personForm.get('description')?.value.length }}/2000</label>
            <label class="error-message" *ngIf="this.personForm.get('description')?.errors?.['minlength'] && this.personForm.get('description')?.touched">
                Debe escribir al menos 200 caracteres.
            </label>
        </div>
        <div class="field mb-5">
            <span class="p-float-label">
                <p-dropdown formControlName="gender" inputId="gender" [options]="genders" optionLabel="name" styleClass="p-inputtext-lg w-full" 
                    placeholder="Seleccionar un género"></p-dropdown>
                <label htmlFor="gender">Género</label>
            </span>
        </div>
        <p style="color: #6c757d;">Ayúdale a tus clientes a saber más de ti… </p>
        <p style="color: #6c757d;">Selecciona una opción de cada categoría (la que mejor te describa):</p>
        <div class="field mb-5 flex flex-row flex-wrap gap-5">
            <div *ngFor="let categoria of categories">
                <label htmlFor="service-{{ categoria }}" style="color: #6c757d;">{{ categoria }}</label>
                <div *ngFor="let service of serviceOptionsByCategory[categoria]" class="p-1">
                    <p-radioButton [inputId]="service.id.toString()" [value]="service" name="service-{{ cleanUrlId(categoria) }}" 
                        formControlName="service-{{ cleanUrlId(categoria) }}"></p-radioButton>
                    <label [for]="service.id.toString()"> {{ service.name }}</label>
                </div>
            </div>
        </div>
        <div class="flex justify-content-center m-4 gap-3">
            <p-button label="Cancelar" (onClick)="goToProfile()" ></p-button>
            <p-button label="Modificar información" type="submit" [disabled]="personForm.invalid || personForm.pristine" ></p-button>
        </div>
    </form>
</div>